export const LastUpdated = '15 mars 2026';
